import createParseMiddleware from './createParseMiddleware';
import { parseRoleResponse } from 'utils/apiParser/roleParser';
import { parseUserResponse } from 'utils/apiParser/userParser';
import { User } from 'types/userTypes';
import { Role } from 'types/roleTypes';

export const parseFetchRolesMiddleware = createParseMiddleware<Role>(parseRoleResponse, 'roles/fetchRoles');
export const parseDescribeRoleMiddleware = createParseMiddleware<Role>(parseRoleResponse, 'roles/describeRole');
export const parseFetchUsersInRoleMiddleware = createParseMiddleware<User>(parseUserResponse, 'roles/fetchUsersInRole');
